import { render, staticRenderFns } from "./JustInSidebar.vue?vue&type=template&id=fa814c0a&scoped=true&"
import script from "./JustInSidebar.vue?vue&type=script&lang=js&"
export * from "./JustInSidebar.vue?vue&type=script&lang=js&"
import style0 from "./JustInSidebar.vue?vue&type=style&index=0&id=fa814c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa814c0a",
  null
  
)

export default component.exports